<template>
  <div>
    <div v-if="normalizedSlotComponents.workPlanExtra.length" class="slot-area slot-area--workPlanExtra gap-5">
      <component
        v-for="(item, idx) in normalizedSlotComponents.workPlanExtra"
        :key="`workPlanExtra_${idx}`"
        :is="item.component"
        v-bind="item.props"
      />
    </div>
  </div>
</template>
  
<script>
import WorkPlanFormUtil from './common/WorkPlanFormUtil.vue'

export default {
  mixins: [WorkPlanFormUtil],
  components: {},
  props: {
    slotComponents: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style scoped>
.gap-5 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  border: 1px solid #000;
  padding: 2px;
}
table {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.border1pxsolid {
  border: 1px solid #000;
  padding: 0;
}
.border1pxsolid-right {
  border-right: 1px solid #000;
  padding: 0;
}
.border1pxsolid-bottom {
  border-bottom: 1px solid #000;
  padding: 0;
}
.border2pxsolid {
  border: 2px solid #000;
  padding: 0;
}
*[contenteditable='true'] {
  background: rgba(200, 250, 230, 0.4);
  cursor: text;
  padding: 2px;
  transition: padding 0.05s linear;
}
span[contenteditable='true']:focus {
  padding: 0 4px;
}
@media print {
  *[contenteditable='true'],
  input {
    background: none;
  }
  .hide-in-print {
    display: none;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
    background: none;
  }
}
.align-center {
  display: flex;
  align-items: center;
}
.checkbox-group {
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1.1;
  margin-bottom: 2px;
}
.table-text-title-justify {
  text-align: justify;
  text-align-last: justify;
  padding: 2px;
  background: #c4c4c4;
}
.table-text-title-justify .line {
  display: block;
  text-align: justify;
  text-align-last: justify;
  white-space: nowrap; /* 줄 안에서 멋대로 줄바꿈 방지 */
}
.table-text-title-center {
  text-align: center;
  text-align-last: center;
  padding: 2px;
  background: #c4c4c4;
}
.text-align-left {
  text-align: left;
}
.text-align-center {
  text-align: center;
  align-items: center;
}
.text-align-right {
  text-align: right;
}
.font-size-9 {
  font-size: 9pt;
  margin: 0;
}
</style>
  
  